// Gruntfile.js uses string-replace-loader to replace these values during build time.
export const VERSION = '5.0.0-beta.0';
export const ID = '2daeb4def8b685227f2a3c924177b40ddcc5bda3';
export const DATE = '2024-09-12T19:16:57.446Z';
